import React, { useEffect, useState } from 'react'
import { ESGLedgerLogo } from './ESGLedgerLogo'

const HOLD_MS = 1000
const FADE_MS = 450

/**
 * Full-screen intro shown once per page load (~1s), then fades out.
 */
const LoadingSplash: React.FC = () => {
  const [visible, setVisible] = useState(true)
  const [fading, setFading] = useState(false)

  useEffect(() => {
    const hold = window.setTimeout(() => setFading(true), HOLD_MS)
    return () => window.clearTimeout(hold)
  }, [])

  useEffect(() => {
    if (!fading) return
    const done = window.setTimeout(() => setVisible(false), FADE_MS)
    return () => window.clearTimeout(done)
  }, [fading])

  useEffect(() => {
    if (!visible) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [visible])

  if (!visible) return null

  return (
    <div
      className={`loading-splash ${fading ? 'loading-splash--out' : ''}`}
      aria-busy="true"
      aria-live="polite"
      role="status"
    >
      <div className="loading-splash__glow loading-splash__glow--a" aria-hidden="true" />
      <div className="loading-splash__glow loading-splash__glow--b" aria-hidden="true" />
      <div className="loading-splash__glow loading-splash__glow--c" aria-hidden="true" />

      <div className="loading-splash__core">
        <div className="loading-splash__halo" aria-hidden="true" />
        <div className="loading-splash__logo">
          <ESGLedgerLogo className="h-16 md:h-20" enlarged />
        </div>
      </div>

      <span className="sr-only">Loading ESGLedger</span>
    </div>
  )
}

export default LoadingSplash
